<template>
    <rkm-modal
        title="Atribuir horario de saida"
        ref="Modal"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-time-picker
                    v-model="horario"
                />
            </rkm-col>
        </rkm-row>

        <template v-slot:footer>
            <rkm-button
                color="primary"
                @click="handleAtribuir"
            >
                Atribuir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    methods: {
        open() {
            this.horario = null
            this.$refs.Modal.show()
        },
        handleAtribuir() {
            this.$emit('atribuir', this.horario)
            this.$refs.Modal.hide()
        },
    },
    data: () => ({
        horario: null
    })
}
</script>